import { render, staticRenderFns } from "./alarmNotice.vue?vue&type=template&id=60c1c34c&scoped=true"
import script from "./alarmNotice.vue?vue&type=script&lang=js"
export * from "./alarmNotice.vue?vue&type=script&lang=js"
import style0 from "./alarmNotice.vue?vue&type=style&index=0&id=60c1c34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c1c34c",
  null
  
)

export default component.exports